// SelectMonthRangeFilter.tsx
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { GridFilterInputValueProps } from '@mui/x-data-grid-premium'
import dayjs from 'dayjs'
import { useMemo } from 'react'

type StandaloneSelectMonthProps = {
  value: string
  onChange: (_value: string) => void
  label?: string
}

const SelectMonthRangeFilter = (props: GridFilterInputValueProps | StandaloneSelectMonthProps) => {
  const isStandalone = !('item' in props)

  // const months = useMemo(() => {
  //   const now = dayjs()
  //   return Array.from({ length: 18 }, (_, i) => now.add(i - 6, 'month').format('YYYY-MM'))
  // }, [])
  const months = useMemo(() => {
    const start = dayjs('2024-01') // Jan 2025
    const end = dayjs().startOf('month') // today’s month (no future months)

    const count = end.diff(start, 'month') + 1
    return Array.from({ length: Math.max(count, 0) }, (_, i) => start.add(i, 'month').format('YYYY-MM')).reverse()
  }, [])

  const handleChange = (event: SelectChangeEvent<string>) => {
    const newValue = event.target.value
    if (isStandalone) {
      props.onChange(newValue)
    } else {
      const { item, applyValue } = props
      applyValue({ ...item, value: [newValue] })
    }
  }

  const selected = isStandalone ? props.value : Array.isArray(props.item?.value) ? props.item.value[0] : ''

  return (
    <FormControl size="small" sx={{ minWidth: 150 }}>
      <InputLabel id="month-select-label">{isStandalone ? props.label ?? 'Month' : 'Month'}</InputLabel>
      <Select
        labelId="month-select-label"
        value={selected ?? ''}
        onChange={handleChange}
        label="Month"
        inputRef={!isStandalone ? props.focusElementRef : undefined}
      >
        {isStandalone && (
          <MenuItem value="">
            <em>All Months</em>
          </MenuItem>
        )}
        {months.map(month => (
          <MenuItem key={month} value={month}>
            {dayjs(month).format('MMM YYYY')}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectMonthRangeFilter

// import React, { useMemo } from 'react'
// import { Select, MenuItem, InputLabel, FormControl, SelectChangeEvent } from '@mui/material'
// import { GridFilterInputValueProps } from '@mui/x-data-grid-premium'
// import dayjs from 'dayjs'

// const SelectMonthRangeFilter = ({
//   monthFilter,
//   onChangeMonth,
// }: {
//   monthFilter: string
//   onChangeMonth: (month: string) => void
// }) => {
//   const handleChange = (event: SelectChangeEvent<string>) => {
//     onChangeMonth(event.target.value)
//   }

//   const months = useMemo(() => {
//     const now = dayjs()
//     return Array.from({ length: 18 }, (_, i) => now.add(i - 6, 'month').format('YYYY-MM'))
//   }, [])

//   return (
//     <FormControl size="small" sx={{ minWidth: 150 }}>
//       <InputLabel id="month-select-label">Month</InputLabel>
//       <Select labelId="month-select-label" value={monthFilter} onChange={handleChange} label="Month">
//         {months.map(month => (
//           <MenuItem key={month} value={month}>
//             {dayjs(month).format('MMM YYYY')}
//           </MenuItem>
//         ))}
//       </Select>
//     </FormControl>
//   )
// }

// export default SelectMonthRangeFilter
